/**
 * **Ablage für kopierte Rechnungszeilen** — wie bei den Arbeitsschritten im Browser, nicht in der
 * Zwischenablage der Belegzeilen: Eine Zeile einer Eingangsrechnung hat in einem Angebot nichts zu suchen.
 * Gemerkt werden nur die Ids; eingefügt wird auf dem Server aus dem aktuellen Stand, mit Rechteprüfung.
 * Die Ablage bleibt nach dem Einfügen gefüllt — dieselben Zeilen in mehrere Rechnungen ist der Normalfall.
 */
export interface ZeilenAblage {
  userId: string
  lineIds: string[]
  /** „Eingangsrechnung 2600002" */
  herkunft: string
}

const ABLAGE = 'symphenia-eingangsrechnung-zeilen-ablage'

export function leseZeilenAblage(userId: string | undefined): ZeilenAblage | null {
  try {
    const roh = JSON.parse(localStorage.getItem(ABLAGE) ?? 'null') as ZeilenAblage | null
    return roh && roh.userId === userId && Array.isArray(roh.lineIds) && roh.lineIds.length ? roh : null
  } catch {
    return null
  }
}

export function schreibeZeilenAblage(ablage: ZeilenAblage | null) {
  try {
    if (ablage) localStorage.setItem(ABLAGE, JSON.stringify(ablage))
    else localStorage.removeItem(ABLAGE)
  } catch {
    /* ohne Speicher keine Ablage über das Neuladen hinaus */
  }
  window.dispatchEvent(new Event(ABLAGE))
}

/** Meldet Änderungen der Ablage — auch aus einem anderen Tab (`storage`). */
export function beobachteZeilenAblage(rueckruf: () => void): () => void {
  const aufStorage = (e: StorageEvent) => e.key === ABLAGE && rueckruf()
  window.addEventListener(ABLAGE, rueckruf)
  window.addEventListener('storage', aufStorage)
  return () => {
    window.removeEventListener(ABLAGE, rueckruf)
    window.removeEventListener('storage', aufStorage)
  }
}
